import React from 'react';
import PropTypes from 'prop-types';
import { Table, TBody, TR, TD, Img } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';

const ACCENT_COLOR = '#1AACEC';
const TEXT_COLOR = '#4A4A4A';

const textStyle = {
  color: TEXT_COLOR,
  fontFamily: "'Nunito', Arial, sans-serif",
  fontSize: '16px',
  lineHeight: '24px',
};

const qrContainer = {
  textAlign: 'center',
  padding: '20px 0',
};

const qrImage = {
  border: `3px solid ${ACCENT_COLOR}`,
  borderRadius: '8px',
};

class BookingConfirmedQRPaymentGuest extends React.Component {
  static propTypes = {
    content: PropTypes.shape({
      guestName: PropTypes.string.isRequired,
      hostName: PropTypes.string,
      guestServiceFee: PropTypes.number,
      currency: PropTypes.string,
      qr: PropTypes.string.isRequired,
      logo: PropTypes.string,
      siteName: PropTypes.string,
    }).isRequired,
  };

  render() {
    const { content: { guestName, hostName, guestServiceFee ,currency, logo, siteName } } = this.props;

    return (
      <Layout>
        <Header color={ACCENT_COLOR} backgroundColor="#F7F7F7" logo={logo} siteName={siteName} />
        <div>
          <Table width="100%">
            <TBody>
              <TR>
                <TD style={textStyle}>
                  <EmptySpace height={20} />
                  <div>Hola {guestName},</div>
                  <EmptySpace height={16} />
                  <div>Tu solicitud de reserva fue aprobada.</div>
                  <EmptySpace height={8} />
                  <div>Tienes 24 horas para pagar la comisión de servicio de {siteName} escaneando el QR de abajo.</div>
                  <EmptySpace height={24} />
                  <div style={qrContainer}>
                    <Img
                      src={`cid:unique@nodemailer.com`}
                      alt="QR Code"
                      width={220}
                      height={220}
                      style={qrImage}
                    />
                  </div>
                  <EmptySpace height={24} />
                  <div>
                    <span style={{ color: ACCENT_COLOR, fontWeight: 'bold' }}>Paso 1</span> — Paga la comisión de {siteName}: <b>{currency === 'BOB' ? 'Bs.' : ''} {guestServiceFee}</b> por QR.
                  </div>
                  <EmptySpace height={12} />
                  <div>
                    <span style={{ color: ACCENT_COLOR, fontWeight: 'bold' }}>Paso 2</span> — Una vez confirmado el pago, te conectamos con {hostName} para coordinar el pago del alojamiento en el método que prefieras.
                  </div>
                  <EmptySpace height={24} />
                  {/* <div>
                    El equipo de {siteName}
                    <br />
                    <a href="https://eslipin.com" style={{ color: ACCENT_COLOR, textDecoration: 'none' }}>eslipin.com</a>
                  </div> */}
                  <EmptySpace height={20} />
                  <EmailSignature siteName={siteName} />
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={40} />
        </div>
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }
}

export default BookingConfirmedQRPaymentGuest;
